function Pricing() {
  const plans = [
    {
      name: "ライト",
      summary: "小さく始めて早く形にしたい方向け",
      features: [
        "小規模サイト制作",
        "基本的な保守対応",
        "メールサポート",
        "月次レポート",
        "セキュリティ更新",
      ],
      recommended: false,
    },
    {
      name: "スタンダード",
      summary: "開発・運用まで一貫して伴走してほしい方向け",
      features: [
        "中規模開発対応",
        "運用・保守込み",
        "優先サポート",
        "週次レポート",
        "パフォーマンス最適化",
        "SEO対策",
        "定期的な改善提案",
      ],
      recommended: true,
    },
    {
      name: "プレミアム",
      summary: "大規模開発や体制構築まで任せたい方向け",
      features: [
        "大規模開発対応",
        "フルサポート体制",
        "24時間対応",
        "リアルタイム監視",
        "専任担当者配置",
        "高度なカスタマイズ",
        "戦略的コンサルティング",
        "無制限の改修対応",
      ],
      recommended: false,
    },
  ];

  return (
    <section
      id="pricing"
      className="relative overflow-hidden bg-red-50 px-6 py-16 md:px-12 md:py-24 lg:px-24"
    >
      <div className="mx-auto max-w-7xl">
        <div className="fade-in-section mb-12 text-center md:mb-16">
          <h2 className="mb-3 text-4xl font-semibold text-gray-900 md:mb-4 md:text-6xl">
            <span className="text-red-500">P</span>ricing
          </h2>
          <p className="text-gray-600">
            料金はプロジェクト内容に合わせて個別お見積もり。ご予算やスケジュールに沿って最適な進め方をご提案します。
          </p>
        </div>
        <div className="grid grid-cols-1 items-stretch gap-8 md:grid-cols-3">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`fade-in-section flex h-full flex-col rounded-2xl border-2 bg-white p-8 shadow-lg transition-all duration-300 md:p-10 ${
                plan.recommended
                  ? "border-red-500 shadow-red-500/20"
                  : "border-gray-200"
              }`}
              style={{ transitionDelay: `${index * 60}ms` }}
            >
              <h3 className="mb-4 flex items-center justify-center gap-2 text-center text-2xl font-semibold text-gray-900">
                {plan.recommended && (
                  <span className="inline-block rounded-full bg-red-500 px-3 py-1 text-xs font-semibold whitespace-nowrap text-white">
                    おすすめ
                  </span>
                )}
                {plan.name}
              </h3>
              <p className="mb-6 text-center text-sm text-gray-600">
                {plan.summary}
              </p>
              <div className="mb-6 flex items-center justify-center gap-2 rounded-lg border border-red-100 bg-red-50 px-4 py-3 text-sm text-gray-900">
                <i className="ri-hand-heart-line text-red-500"></i>
                <span>費用とスケジュールはヒアリング後にご提案します</span>
              </div>
              <div className="mb-6 h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>
              <ul className="mb-8 flex-1 space-y-4">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-3 text-sm">
                    <i className="ri-check-line flex-shrink-0 text-lg text-red-500"></i>
                    <span className="text-gray-600">{feature}</span>
                  </li>
                ))}
              </ul>
              <a
                href="#contact"
                className={`mt-auto w-full cursor-pointer rounded-lg py-3 text-center font-semibold whitespace-nowrap transition-all duration-300 ${
                  plan.recommended
                    ? "bg-red-500 text-white"
                    : "border-2 border-red-500 bg-transparent text-red-500"
                }`}
              >
                無料相談する
              </a>
            </div>
          ))}
        </div>
        <div className="fade-in-section mt-12 text-center">
          <p className="text-sm text-gray-500">
            目的・優先度・ご予算に合わせて柔軟にプランニングしますので、まずはお問い合わせください。
          </p>
        </div>
      </div>
    </section>
  );
}

export default Pricing;
